<template>
  <div>
    <div
      v-if="plain_text"
      ref="content_inner"
      class="content mb-0 text-pretty whitespace-pre-wrap"
      data-test="text-content"
      :style="clamp_style"
    >
      {{ html_text }}
    </div>
    <div
      v-else
      ref="content_inner"
      class="content mb-0 text-pretty"
      data-test="text-content"
      :style="clamp_style"
      v-html="html_text"
    />
    <button
      v-if="is_overflowing"
      type="button"
      class="mt-1 inline-flex items-center gap-1 text-sm font-semibold text-primary-500"
      :aria-expanded="is_expanded"
      @click.stop="is_expanded = !is_expanded"
    >
      {{ $t(is_expanded ? 'editor_ziggu.actions.showLess' : 'editor_ziggu.actions.showMore') }}
      <AppIcon
        name="regular-chevron-down"
        class="transition-transform duration-200"
        :class="{ 'rotate-180': is_expanded }"
      />
    </button>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref, watch } from 'vue';

const props = defineProps({
  html_text: { type: String, required: true },
  lines: { type: Number, default: 4 },
  plain_text: { type: Boolean },
});

const content_inner = ref(null);
const is_expanded = ref(false);
const is_overflowing = ref(false);

const clamp_style = computed(() => {
  if (is_expanded.value) return {};
  return {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: String(props.lines),
    overflow: 'hidden',
  };
});

const measureOverflow = async () => {
  await nextTick();
  if (!content_inner.value) return;
  is_overflowing.value = content_inner.value.scrollHeight > content_inner.value.clientHeight + 1;
};

onMounted(measureOverflow);

watch(
  () => props.html_text,
  () => {
    is_expanded.value = false;
    measureOverflow();
  },
);
</script>
